var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap-nav"},[_c('ul',{staticClass:"list-nav",class:{ 'ranking-nav': _vm.isRanking }},_vm._l((_vm.navList),function(item){return _c('li',{key:item.name,class:{ on: item[_vm.linkType].toString() === _vm.current }},[_c('router-link',{attrs:{"to":{
          path: ("/challenge/" + _vm.navType + "/" + (item[_vm.linkType])),
          params: {
            genreId: item[_vm.linkType]
          }
        }}},[_vm._v(" "+_vm._s(item.name)+" ")])],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }